import { render } from "./sport-live-tv-dropdown-transition.vue?vue&type=template&id=0a6ed43a"
const script = {}

import "./sport-live-tv-dropdown-transition.vue?vue&type=style&index=0&id=0a6ed43a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__